'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import Select from 'react-select';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import XLSX from "xlsx/dist/xlsx.full.min.js";
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY,getHyphenYYYYMMDDHHMMSS,getHyphenDDMMYYYYHHMMSS,getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS, getCellValue, findByFieldIgnoreCase, isSameIgnoreCase } from '../common/utils';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import ConsigneesMapView from './consigneesMapView';
import { alphaNumerate } from 'chartist';
import {verifyext, verifycsvdata} from "../common/verifyext";
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
import { Edit } from 'lucide-react';
import AddEditController from './addEditController.js';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent="";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




export default class LmConsignees extends Component {
  static contextType = LoadingPortContext;

  constructor(props, context) {
    super(props, context);
    this._lastLoadingPortCode = context ? context.loading_port_code : null;
      this.state = {
        isMapOpen: true,
        modules : AllModules,
        defaultColDef: {
            sortable: true,
            filter: true,
            editable: true,
        },
        eventAction: null,
        show: false,
        frameworkComponents : {
          consignmentforceclose:Consignmentforceclose,
          consignmentActions:ConsignmentActions,
          UpdateButton:UpdateButton,
          MarkDeliver : MarkDeliver,
          commentActions : CommentActions,
          actionRenderer: this.ActionRenderer
        },
        modified_by:"",
        basicTitle:'',
        basicMessage:'',
        reasonforceclose:"",
        bulkslide:"",
        file:"",
        fileName:"",
        errors:[],
        validData:[],
        uploadFile:"",
        basicType:"default",
        loadshow:'show-n',
        forceCloseRowNode : "",
        forceclosedata:"",
        csvcontent:"",
        sliderForceCloseTranslate:"",
        overly:'',
        rowData:[],
        bulkslide:"",
        showDiv:"",
        uploadDivWidth:"",
        mapinfo:"",
        dealer:"",
        sliderCommentTranslate:"",
        commentsRowData:"",
        consignment_code:"",
        sliderRouteTranslate:"",
        maptruckno:"",
        routeTruck:	"",
        rownode:"",
        googelRoutes:"",
        file:"",
        rowSelection:'multiple',
        sliderForceCloseTranslate:"",
        maptruckno:"",
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
            statusBar: {
        statusPanels: [
          {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left"
          },
          {
          statusPanel: "agTotalRowCountComponent",
          align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
        ]
            },
        paginationPageSize:200,
        geofencelist:[],
        geoFenceData:"",
        sideBar: {
          toolPanels: [
            {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel"
            },
            {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel"
            }
          ]
        },
        animateRows: true,
        dept_code:"",
        pagetitle:"",
        markDeliverRowNode : "",
        markDeliverData:"",
        sliderMarkDeliverTranslate:"",
        csvData:0,
        overly:"show-n",
        loadshow:"show-n",
        holidayEvents : [],
        showCalendar : "show-m",
        showGridData : "show-m",
        sliderTitle : "Bulk Upload",
        statesList : [],
        zonesList : [],
        zonesByState : {},
        // Zone Override upload (Consignee Code + Zone only) - separate from Import Data, which
        // is insert-oriented and rejects consignees that already exist.
        zoneSlide : false,
        zoneFileName : "",
        zoneRows : [],
        zoneErrors : [],
        zoneSubmitting : false,
        routesList : [],
        pageAccess: "",
        rowIds : [],
        selectedRows : [],
        comp_code : "",
        lpNames : [],
        loading_port_code : "",
        vehicleCap: [],
        cityGroup:[],
        vehicleCapresults:[],
        controller : {
            open : false
        }
        //components : {datepicker:getDatePicker()}
    }
    this.changeFileHandlerLatLng = this.changeFileHandlerLatLng.bind(this);
    this.onCellClicked = this.onCellClicked.bind(this);
    this.checkFileData = this.checkFileData.bind(this);
    this.gridRef = React.createRef();
    this.fileInputRef = React.createRef();
  }

componentDidMount(){
    loadDateTimeScript();
    this.pageAccess();
    redirectURL.post("/lmconsignees/getLmStates").then((response)=>{
        var states = response.data;
        var statesList = [];
        if(states.length > 0)
        {
            states.map((item) =>{
                statesList.push(item.state)
            })
        }
        this.setState({
            statesList : statesList,
        })
    }).catch((e)=>{
        console.log(e);
    })
    var zonesList = [];
    var routesList = [];
    var rtList = 50;
    for(var rt=1;rt<51;rt++)
    {
        routesList.push("ROUTE"+rt);
    }
    var groupList = [];
    for(var rt=1;rt<51;rt++)
    {
        groupList.push("GROUP"+rt);
    }
    this.setState({
        routesList : routesList,
        cityGroup : groupList,
    });
}
loadZonesForWarehouse(){
    // Zones come from THIS warehouse's SOB Zones master, not a hardcoded guess: the engine
    // ignores a consignee zone the warehouse does not configure (it would have no vehicles and
    // no freight), so offering an unconfigured zone would only create a mapping that does nothing.
    // Called from onLoadPageData, i.e. only once the warehouse is known. It used to run in
    // componentDidMount, where loading_port_code is still "" - and this endpoint queried with a
    // blank warehouse returns NOTHING, so every consignee (DELHI included, which spans DELHI NCR
    // and EAST) was told "no override needed". It also never refreshed on a warehouse switch.
    var lpc = this.state.loading_port_code;
    if (!lpc) { return; }
    redirectURL.post("/lmconsignees/getLmSobZones", { loading_port_code: lpc })
        .then((response) => {
            if (this.state.loading_port_code !== lpc) { return; }   // warehouse changed mid-flight
            var zones = [];
            var byState = {};
            (response.data || []).forEach((row) => {
                var z = String(row.zone || "").trim();
                var st = String(row.state || "").trim().toUpperCase();
                if (!z) { return; }
                if (zones.indexOf(z) === -1) { zones.push(z); }
                if (st) {
                    if (!byState[st]) { byState[st] = []; }
                    if (byState[st].indexOf(z) === -1) { byState[st].push(z); }
                }
            });
            Object.keys(byState).forEach((k) => { byState[k].sort(); });
            this.setState({ zonesList: zones.sort(), zonesByState: byState });
        }).catch((e) => { console.log(e); });
}
onLoadPageData(){
    this.loadZonesForWarehouse();
    this.setState({
        overly:"show-m",
        loadshow:"show-m",
    })
    // Restricted Vehicles must offer EVERY vehicle type the warehouse runs, across all planning
    // types. getLmVehicleCapacity / getLmVehicleDetails both default data_type to 1 (REGULAR), so
    // a type configured only for DEDICATED or COURIER never appeared in this dropdown and could
    // not be restricted. getVehicleDetails takes the whole body as the query and returns the
    // DISTINCT vehicle_cap list, so omitting data_type gives the union.
    // hub_vehicle is deliberately NOT filtered, so HUB vehicle types are restrictable too. The old
    // endpoint excluded them by DEFAULT (`req.body.hub_vehicle || 0`); getVehicleDetails uses the
    // body verbatim, so simply omitting the key lists hub and non-hub together.
    // Restricting a hub consignee from its hub vehicles does NOT strand it: preprocessing moves
    // hub dealers into a {hub}_HUB zone whose only vehicles are the hub types, so the dealer ends
    // REGULAR Pass 1 as a Courier residual, and revalidate_hub_residuals_for_regular then switches
    // it back to its real geo zone + non-hub vehicle set for Pass 2 - i.e. it plans with the
    // regular loads, provided it has a real non-hub freight rate. With no such rate it stays on
    // the hub-hold path (HUB HOLD / Courier). Nothing crashes either way.
    // air_courier_vehicle stays filtered out: air courier is selected from ORDER attributes
    // (order category / floor / OD / H), not from this field, so listing it here would offer a
    // restriction that does nothing.
    var params = {
        'loading_port_code' : this.state.loading_port_code,
        'status' : 1,
        'air_courier_vehicle' : 0
    }
    console.log(params,"params")

    redirectURL.post("/lmconsignees/getVehicleDetails",params).then((response)=>{
        var results = (response.data && response.data.allRecords) ? response.data.allRecords : [];
        var distinctCaps = (response.data && response.data.records) ? response.data.records : [];
        var vehicleCap= [{value:"None",label:"None"},{value:"All",label:"All"}]
        var addedVehicleCaps = [];
        distinctCaps.map((cap) => {
            if(cap && addedVehicleCaps.indexOf(cap) == -1){
                addedVehicleCaps.push(cap);
                vehicleCap.push({
                    value:cap,
                    label:cap
                })
            }
        })
        console.log(vehicleCap,"vehicleCap")
        this.setState({
            vehicleCap : vehicleCap,
            vehicleCapresults : results
        })
        
    }).catch((e)=>{
        console.log(e);
    })
    redirectURL.post("/lmconsignees/getLmConsignees",params).then((response)=>{
        console.log(response.data);
        this.setState({
            rowData : response.data,
            selectedRows : [],
            overly:"show-n",
            loadshow:"show-n",
        })
        if(this.gridApi)
        {
            this.gridApi.deselectAll();
        }
    }).catch((e)=>{
        console.log(e);
    })
}
async pageAccess(){
    this.setState({
        loadshow:'show-m',
        overly:'show-m',
    })
    var currentUrl = this.props.match.path;
    var resolved = await resolvePageAccess(currentUrl, this.context);
    if (!resolved) {
        // No access (already alerted+redirected), empty port list, or a logged request error.
        this.setState({ loadshow: 'show-n', overly: 'show-n' });
        return;
    }
    this._lastLoadingPortCode = resolved.loading_port_code;
    this.setState({
        pageAccess: resolved.pageAccess,
        loading_port_code: resolved.loading_port_code,
        comp_code: resolved.comp_code,
        lpNames: resolved.lpNames,
        loadshow: 'show-n',
        overly: 'show-n',
    });
    await this.onLoadPageData();
}
onGridReady = params => {
    this.gridApi = params.api;  
    //console.log("Grid is: ", params);
    this.gridColumnApi = params.columnApi;
};
onGridState = () =>{
        //console.log(this.gridApi);
    
        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
                
        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
}



closeAlert = () => {
    this.setState({
        show: false,
        basicMessage: ""
    });
    // window.location.reload();
}

onCellClicked(e)
{
    if(e.colDef.field == "container_no")
    {
        console.log(e.data.container_no);
    }
}

onClickHideAll(){
    this.setState({
    loadshow:'show-n',
    overly:'show-n',
    bulkslide:"",
    fileName:"",
    errors:[],
    validData:[],
    // the overlay closes the Zone Overrides slider too, same as Import Data
    zoneSlide:false,
    zoneRows:[],
    zoneErrors:[],
    zoneFileName:"",
    });
    if(this.fileInputRef && this.fileInputRef.current){
        this.fileInputRef.current.value = "";
    }
}
toggleMapOpen = () => {
    this.setState({ isMapOpen: !this.state.isMapOpen });
}
saveConsigneeDetails(params, type = "update")
{
    //console.log(params);
    // No "unchanged" guard needed here - AddEditController.onClickSubmit already
    // compares formData vs currentData for every active field and blocks a no-op
    // update ("No changes found...") before onUpdate/onUpdateFreight ever fires.

    // A new consignee's code must not collide with one already in the grid - same
    // uniqueness rule the bulk-upload path (validateExcelData) already enforces.
    if (type === "add") {
        var codeToCheck = String(params.consignee_code || "").trim().toUpperCase();
        var codeAlreadyExists = codeToCheck && (this.state.rowData || []).some((r) =>
            String(r.consignee_code || "").trim().toUpperCase() === codeToCheck
        );
        if (codeAlreadyExists) {
            this.setState({
                basicTitle: "Consignee Code already exists.",
                basicType: "warning",
                show: true
            });
            return;
        }
    }

    var restrictedVehicles = Array.isArray(params.restricted_vehicles) ? params.restricted_vehicles : (params.restricted_vehicles ? [params.restricted_vehicles] : []);
    // Restricted Vehicles is optional - nothing selected defaults to "None" right
    // before hitting the API, same fallback the bulk-upload path already uses.
    if (restrictedVehicles.length === 0) {
        restrictedVehicles = ["None"];
    }
    if(params.category !="" && params.category !=undefined && params.consignee_code !='' && params.consignee_code !=undefined && params.customer_id !="" && params.customer_id !=undefined  && params.consignee_name !="" && params.consignee_name !=undefined && params.city_grouping !='' && params.city_grouping !=undefined)
    {
        // "None" (no vehicles restricted - everything allowed) and "All" (every
        // vehicle restricted - nothing allowed) are opposite states, so they must
        // send different payloads - only "All" expands to the concrete vehicle list.
        if (restrictedVehicles.includes("None")) {
            restrictedVehicles = ["None"];
        } else if (restrictedVehicles.includes("All")) {
            var ltData = [];
            this.state.vehicleCapresults.map((vc) => {
                if (ltData.indexOf(vc.vehicle_cap) === -1) {
                    ltData.push(vc.vehicle_cap);
                }
            })
            restrictedVehicles = ltData;
        }
        params.restricted_vehicles = restrictedVehicles;
        this.setState({
            overly:"show-m",
            loadshow:"show-m",
        })
        params['user_name'] = localStorage.getItem('username');
        params['email'] = localStorage.getItem('email');
        params['user_department'] = localStorage.getItem('lm_department');
        params['user_role'] = localStorage.getItem('roles');
        params['staff_id'] = localStorage.getItem('staff_id');
        params['designation'] = localStorage.getItem('designation');
        params['comp_code'] = this.state.comp_code;
        params['loading_port_code'] = this.state.loading_port_code;
        redirectURL.post("/lmconsignees/savelmconsignees",params).then((response)=>{
            console.log(response);
            if(response.data.message == "Success")
            {
                this.setState({
                    basicTitle: type === "add" ? "Added Successfully." : "Updated Successfully.",
                    basicType : "success",
                    show : true,
                    overly:"show-n",
                    loadshow:"show-n",
                    controller : { open : false }
                })
                //window.location.reload();
                this.onLoadPageData();
            }
            else
            {
                this.setState({
                    basicTitle: type === "add" ? "Failed to Add." : "Failed to update.",
                    basicType : "warning",
                    show : true,
                    overly:"show-n",
                    loadshow:"show-n"
                })
            }
        }).catch((e)=>{
            console.log(e);
            this.setState({
                basicTitle: type === "add" ? "Failed to Add." : "Failed to update.",
                basicType : "warning",
                show : true,
                overly:"show-n",
                loadshow:"show-n"
            })
        })
    }
    else
    {
        this.setState({
            basicTitle:"Fields Should not be Empty.",
            basicType : "warning",
            show : true
        })
    }
}
buildConsigneeFormResourceArray(isAddMode, currentRow) {
    currentRow = currentRow || {};
    var statesArray = this.state.statesList.map((each) => ({ label: each, value: each }));
    var cityGroupArray = this.state.cityGroup.map((each) => ({ label: each, value: each }));
    // Zones this consignee's STATE is configured for. Falls back to every zone of the
    // warehouse when the state is not known yet (the Add form, before a state is picked).
    var rowState = String(currentRow.state || "").trim().toUpperCase();
    var zonesForState = (this.state.zonesByState || {})[rowState];
    var zoneSource = (zonesForState && zonesForState.length > 0)
        ? zonesForState : (this.state.zonesList || []);
    var zoneArray = zoneSource.map((each) => ({ label: each, value: each }));
    // An existing value that is no longer configured must still be visible, otherwise the form
    // would silently show blank for a consignee that does carry a mapping.
    var currentZone = String(currentRow.zone_override || "").trim();
    if (currentZone && !zoneArray.some((o) => o.value === currentZone)) {
        zoneArray = [{ label: currentZone + " (not configured)", value: currentZone }].concat(zoneArray);
    }
    var zoneSpansTwo = zoneArray.length > 1;
    // Zones not loaded (yet, or the fetch failed) is NOT the same as "this state has one zone".
    // Never disable the field on missing data - that is how DELHI was wrongly locked.
    var zonesUnknown = !(this.state.zonesList && this.state.zonesList.length > 0);
    var vehicleCapArray = this.state.vehicleCap.map((each) => ({ label: each.label, value: each.value }));
    // Identity fields (code/name/address etc.) are locked once a consignee exists -
    // editing only touches lat/lng/restricted vehicles/city grouping. A brand new
    // consignee has none of that yet, so these must be enterable while adding.
    var identityDisabled = !isAddMode;
    return [
        { id: 0, title: "Category", field: "category", type: "input", input_type: "text", errMsg: "Please enter the category.", is_active: true, is_disabled: identityDisabled, is_required: true },
        { id: 1, title: "Customer Id", field: "customer_id", type: "input", input_type: "text", errMsg: "Please enter the customer id.", is_active: true, is_disabled: identityDisabled, is_required: true },
        { id: 2, title: "Consignee Code", field: "consignee_code", type: "input", input_type: "text", errMsg: "Please enter the consignee code.", is_active: true, is_disabled: identityDisabled, is_required: true },
        { id: 3, title: "Consignee Name", field: "consignee_name", type: "input", input_type: "text", errMsg: "Please enter the consignee name.", is_active: true, is_disabled: identityDisabled, is_required: true },
        { id: 4, title: "Round", field: "round", type: "input", input_type: "number", errMsg: "Please enter the round.", is_active: true, is_disabled: identityDisabled, is_required: true },
        { id: 5, title: "Sub Round", field: "sub_round", type: "input", input_type: "text", errMsg: "Please enter the sub round.", is_active: true, is_disabled: identityDisabled, is_required: true },
        { id: 6, title: "Address Line 1", field: "arrd_line_1", type: "input", input_type: "text", errMsg: "Please enter the address line 1.", is_active: true, is_disabled: identityDisabled, is_required: true },
        { id: 7, title: "Address Line 2", field: "arrd_line_2", type: "input", input_type: "text", errMsg: "", is_active: true, is_disabled: identityDisabled, is_required: false },
        { id: 8, title: "Address Line 3", field: "arrd_line_3", type: "input", input_type: "text", errMsg: "", is_active: true, is_disabled: identityDisabled, is_required: false },
        { id: 9, title: "City", field: "city", type: "input", input_type: "text", errMsg: "Please enter the city.", is_active: true, is_disabled: identityDisabled, is_required: true },
        // State must come from the state master: a typed value (" UTTAR PRADESH", a city name)
        // was saved as-is and later broke freight / zone lookups, which match exactly. It is only
        // enterable while ADDING (identity fields lock on edit), so the dropdown is Add-only - the
        // locked edit view keeps the plain text so a stored value in a different case still shows.
        isAddMode
            ? { id: 10, title: "State", field: "state", type: "dropdown", optionsArray: statesArray, errMsg: "Please select the state.", is_active: true, is_disabled: false, is_required: true }
            : { id: 10, title: "State", field: "state", type: "input", input_type: "text", errMsg: "Please enter the state.", is_active: true, is_disabled: identityDisabled, is_required: true },
        { id: 11, title: "Pincode", field: "pincode", type: "input", input_type: "number", errMsg: "Please enter the pincode.", is_active: true, is_disabled: identityDisabled, is_required: true },
        { id: 12, title: "Latitude", field: "lat", type: "input", input_type: "number", errMsg: "Please enter the latitude.", is_active: true, is_disabled: false, is_required: true },
        { id: 13, title: "Longitude", field: "lng", type: "input", input_type: "number", errMsg: "Please enter the longitude.", is_active: true, is_disabled: false, is_required: true },
        {
            id: 14, title: "Restricted Vehicles", field: "restricted_vehicles", type: "multiselect", optionsArray: vehicleCapArray,
            errMsg: "Please select the restricted vehicles.", is_active: true, is_disabled: false, is_required: false,
            onSelectValues: (values, prevValues) => {
                // "None" and "All" are blanket states - they can't coexist with each
                // other or with specific vehicle types in the same selection.
                var noneJustAdded = values.indexOf("None") !== -1 && prevValues.indexOf("None") === -1;
                var allJustAdded = values.indexOf("All") !== -1 && prevValues.indexOf("All") === -1;
                if (noneJustAdded) {
                    return ["None"];
                } else if (allJustAdded) {
                    return ["All"];
                } else {
                    var specificValues = values.filter((v) => v !== "None" && v !== "All");
                    // If every individual vehicle ends up picked one by one, that's
                    // the same as picking "All" - collapse it to the "All" chip.
                    var allVehicleValues = vehicleCapArray.map((o) => o.value).filter((v) => v !== "None" && v !== "All");
                    var allIndividuallySelected = allVehicleValues.length > 0 &&
                        specificValues.length === allVehicleValues.length &&
                        allVehicleValues.every((v) => specificValues.indexOf(v) !== -1);
                    return allIndividuallySelected ? ["All"] : specificValues;
                }
            }
        },
        { id: 15, title: "City Grouping", field: "city_grouping", type: "dropdown", optionsArray: cityGroupArray, errMsg: "Please select the city grouping.", is_active: true, is_disabled: false, is_required: true },
        // OPTIONAL. Blank = not overridden, and planning falls back to the city's zone in Route
        // Config and then to the state's default zone in SOB Zones. Set it only where the city
        // itself is not decisive - e.g. a Gurgaon consignee that ships on upcountry loads while
        // its neighbours ship NCR.
        {
            id: 16, title: "Zone (override)", field: "zone_override", type: "dropdown",
            optionsArray: zoneArray,
            isClearable: true,
            placeholder: (zoneSpansTwo || zonesUnknown)
                ? "Leave blank to follow the city / state"
                : "Not needed - this state has one zone",
            note: zonesUnknown
                ? "Zones for this warehouse could not be loaded - reopen the form to try again."
                : (zoneSpansTwo
                    ? "Set this only when the consignee must plan in a different zone from the rest of its city. Clear it to follow the city, then the state."
                    : "This consignee's state is configured for a single zone, so no override is needed."),
            errMsg: "", is_active: true, is_disabled: !zoneSpansTwo && !zonesUnknown, is_required: false
        },
    ];
}
handleEdit = (params) => {
    var rowData = params.data || {};
    var existingVehicles = rowData.restricted_vehicles || [];
    if (!Array.isArray(existingVehicles)) {
        existingVehicles = existingVehicles ? [existingVehicles] : [];
    }
    // If the saved list happens to cover every available vehicle type, that's
    // the expanded form of "All" - show it in the dropdown as just "All"
    // instead of every individual vehicle name.
    if (existingVehicles.indexOf("None") === -1 && existingVehicles.indexOf("All") === -1) {
        var allVehicleCaps = [];
        this.state.vehicleCapresults.map((vc) => {
            if (allVehicleCaps.indexOf(vc.vehicle_cap) === -1) {
                allVehicleCaps.push(vc.vehicle_cap);
            }
        });
        var isAllSelected = allVehicleCaps.length > 0 &&
            existingVehicles.length === allVehicleCaps.length &&
            allVehicleCaps.every((v) => existingVehicles.indexOf(v) !== -1);
        if (isAllSelected) {
            existingVehicles = ["All"];
        }
    }
    this.setState({
        controller: {
            open: true,
            title: "Edit Consignee",
            btnType: "Update",
            formResourceArray: this.buildConsigneeFormResourceArray(false, rowData),
            type: "update",
            formData: { ...rowData, restricted_vehicles: existingVehicles }
        }
    })
};
ActionRenderer = (props) => (
    <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>
        <Edit className="text-primary cursor-pointer ml-2"
            size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleEdit(props) }} />
    </div>
);
onUpdateFreight = (object, type) => {
    this.saveConsigneeDetails({ ...object }, type);
}
// Same pattern as lmvehiclecapacity.js's addNewRow(): open the same slider used
// for editing, just with type "add" instead of "update". Restricted Vehicles/City
// Grouping start pre-filled with the same defaults the bulk-upload path falls back
// to (None/GROUP1) rather than blank, since both are required fields here.
addNewRow()
{
    this.setState({
        controller: {
            open: true,
            title: "Add Consignee",
            btnType: "Add",
            formResourceArray: this.buildConsigneeFormResourceArray(true),
            type: "add",
            formData: { restricted_vehicles: ["None"], city_grouping: "GROUP1" }
        }
    })
}
showGrid(){
    this.setState({
        showCalendar : "show-n",
        showGridData  : "show-m"
    })
}
onClickDataExport(){
    var params = {
        fileName: "consignees.csv"
    };
    this.gridApi.exportDataAsCsv(params);
}
onClickBulkDelete(){
    var rowIds = this.state.rowIds;
    console.log(rowIds,"rowIds")
    if(rowIds.length > 0)
    {
        var qry = {
            rowIds:rowIds,
            comp_code: this.state.comp_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
        }
        
        //var confirm = confirm("Are You Sure! Do you want really delete?");
        if (window.confirm("Are You Sure! Do you want really delete?"))
        {
            redirectURL.post("/lmconsignees/deleteBulkLmConsignees",qry).then((response)=>{
                console.log(response.data);
                if(response.data.message == "Success")
                {
                    this.setState({
                        basicTitle:"Deleted Successfully.",
                        basicType : "success",
                        show : true,
                        rowIds : []
                    })
                    //window.location.reload();
                    this.onLoadPageData();
                }
                else
                {
                    this.setState({
                        basicTitle:"Failed to Delete.",
                        basicType : "warning",
                        show : true
                    })
                }
            }).catch((e)=>{
                console.log(e);
            })
        } 
    }
    else
    {
        this.setState({
            basicTitle:"Please select the Row(s) to continue.",
            basicType : "warning",
            show : true
        })
    }
}
// ---------------------------------------------------------------------------------------------
// ZONE OVERRIDE UPLOAD
// ---------------------------------------------------------------------------------------------
// Consignees whose STATE spans more than one zone - the only ones for which an override can
// mean anything. Everyone else follows their single state zone and is left out of the template.
consigneesNeedingZoneDecision(){
    var byState = this.state.zonesByState || {};
    return (this.state.rowData || []).filter((r) => {
        var zs = byState[String(r.state || "").trim().toUpperCase()];
        return zs && zs.length > 1;
    });
}
downloadZoneTemplate = () => {
    var byState = this.state.zonesByState || {};
    var rows = this.consigneesNeedingZoneDecision();
    var esc = (v) => {
        var t = String(v == undefined ? "" : v);
        return /[",\n]/.test(t) ? '"' + t.replace(/"/g, '""') + '"' : t;
    };
    // Only "Consignee Code" and "Zone" are read back on upload; the other columns are there so
    // whoever fills it in can see which consignee is which and which zones it may take.
    var lines = ["Consignee Code,Consignee Name,City,State,Allowed Zones,Zone"];
    rows.forEach((r) => {
        var st = String(r.state || "").trim().toUpperCase();
        lines.push([r.consignee_code, r.consignee_name, r.city, r.state,
                    (byState[st] || []).join(" / "), r.zone_override || ""].map(esc).join(","));
    });
    if (rows.length === 0) {
        lines.push(",,,,No state in this warehouse spans more than one zone,");
    }
    var blob = new Blob([lines.join("\r\n")], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "zone_override_" + (this.state.loading_port_code || "warehouse") + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
handleZoneFile = (e) => {
    var file = e.target.files[0];
    e.target.value = "";
    if (!file) { return; }
    this.setState({ zoneFileName: file.name });
    var reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = (event) => {
        var workbook = XLSX.read(new Uint8Array(event.target.result), { type: "array" });
        var sheet = workbook.Sheets[workbook.SheetNames[0]];
        this.validateZoneRows(XLSX.utils.sheet_to_json(sheet, { defval: "" }));
    };
}
validateZoneRows = (data) => {
    var byState = this.state.zonesByState || {};
    var byCode = {};
    (this.state.rowData || []).forEach((r) => {
        byCode[String(r.consignee_code || "").trim().toUpperCase()] = r;
    });
    var key = (z) => String(z || "").replace(/\s+/g, "").toUpperCase();
    var lastIdx = {};
    data.forEach((row, i) => {
        var c = String(getCellValue(row, "Consignee Code") || "").trim().toUpperCase();
        if (c) { lastIdx[c] = i; }
    });
    var errors = [], valid = [];
    var hasZoneCol = data.some((row) => Object.keys(row || {}).some(
        (k) => String(k).trim().toLowerCase() === "zone"));
    if (!hasZoneCol) {
        errors.push({ row: "", errors: ["The file has no \"Zone\" column - download the template and fill it in"] });
        this.setState({ zoneErrors: errors, zoneRows: [] });
        return;
    }
    data.forEach((row, i) => {
        var rowNo = i + 2;
        var code = String(getCellValue(row, "Consignee Code") || "").trim();
        var zone = String(getCellValue(row, "Zone") || "").trim();
        var errs = [];
        var rec = byCode[code.toUpperCase()];
        if (!code) {
            errs.push("Consignee Code is required");
        } else if (!rec) {
            errs.push("Consignee Code \"" + code + "\" does not exist in this warehouse");
        } else if (lastIdx[code.toUpperCase()] !== i) {
            errs.push("Consignee Code \"" + code + "\" repeats in this file - row "
                      + (lastIdx[code.toUpperCase()] + 2) + " (the last one) is used instead");
        } else if (zone) {
            var allowed = byState[String(rec.state || "").trim().toUpperCase()] || [];
            var hit = allowed.filter((z) => key(z) === key(zone))[0];
            if (allowed.length === 1) {
                // a single-zone state needs no override; storing one would silently pin the
                // consignee if a second zone is added to the state later
                errs.push(rec.state + " has only one zone - no override needed");
            } else if (!hit) {
                errs.push("Zone \"" + zone + "\" is not configured for " + rec.state
                          + " - allowed: " + (allowed.join(", ") || "none"));
            } else {
                zone = hit;
            }
        }
        if (errs.length > 0) {
            errors.push({ row: rowNo, errors: errs });
        } else if (code) {
            // a blank Zone is valid and means "clear the override"
            valid.push({ consignee_code: rec.consignee_code, zone: zone });
        }
    });
    this.setState({ zoneErrors: errors, zoneRows: valid });
}
submitZoneUpload = async () => {
    if (this.state.zoneRows.length === 0) { return; }
    this.setState({ zoneSubmitting: true });
    try {
        var response = await redirectURL.post("/lmconsignees/bulkUpdateConsigneeZones", {
            loading_port_code: this.state.loading_port_code,
            rows: this.state.zoneRows,
            comp_code: this.state.comp_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
        });
        var d = response.data || {};
        var partial = (d.invalid || []).length > 0 || (d.not_found || []).length > 0;
        this.setState({
            zoneSubmitting: false, zoneSlide: false, zoneRows: [], zoneErrors: [], zoneFileName: "",
            basicTitle: d.message || "Zone overrides updated.",
            basicType: partial ? "warning" : "success",
            show: true,
        });
        this.onLoadPageData();
    } catch (e) {
        console.log(e);
        var msg = (e && e.response && e.response.data && e.response.data.message) ? e.response.data.message : "";
        this.setState({ zoneSubmitting: false, basicTitle: msg || "Failed to update zone overrides.",
                        basicType: "warning", show: true });
    }
}
closeZoneSlide = () => {
    this.setState({ zoneSlide: false, zoneRows: [], zoneErrors: [], zoneFileName: "", overly: "show-n" });
}
showBulkUpload(){
    this.setState({
        overly :"show-m",
        bulkslide : "slider-translate",
        errors: [],
        validData: [],
        fileName: ""
    })
}
getShortFileName = (name, maxLength = 31) => {
    const lastDot = name.lastIndexOf(".");
    const baseName = lastDot > -1 ? name.substring(0, lastDot) : name;
    const extension = lastDot > -1 ? name.substring(lastDot) : "";

    if (baseName.length <= maxLength) return name;

    return baseName.substring(0, maxLength) + "..." + extension;
};
// Same engine as lmvehiclecapacity.js / lmtransporters.js: read the file with
// XLSX/FileReader (not CSVFileValidator), validate row-by-row into errorList +
// cleanedData, and only ever submit cleanedData (validData) - never the raw rows.
handleFileChange = (e) => {
    const file = e.target.files[0];
    e.target.value = ""; // reset immediately

    if (!file) return;
    this.setState({ fileName: file.name });

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = (event) => {
        const workbook = XLSX.read(
            new Uint8Array(event.target.result),
            { type: "array" }
        );

        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        this.validateExcelData(data);
    };
};

validateExcelData = (data) => {
    let errorList = [];
    let cleanedData = [];

    // Does the sheet carry a Zone column at all? Checked once over the header keys rather than
    // per cell, so "column absent" and "cell blank" stay distinguishable downstream.
    const hasZoneColumn = (data || []).some((row) => Object.keys(row || {}).some(
        (k) => String(k).trim().toLowerCase() === "zone"));
    // Only zones this warehouse actually configures are accepted - the engine ignores any
    // other value, so letting it upload would create a mapping that silently does nothing.
    const validZones = (this.state.zonesList || []).map((z) => String(z).trim().toUpperCase());

    // consignee_code is unique - anything already sitting in the grid (already
    // fetched from the DB into this.state.rowData) shouldn't be re-uploaded.
    let existingCodes = new Set(
        (this.state.rowData || []).map((r) => String(r.consignee_code || "").trim().toUpperCase())
    );

    // consignee_code must also be unique WITHIN the uploaded file itself - the same
    // row pasted/uploaded twice in one file wouldn't match anything in existingCodes
    // (it's not in the DB yet). When a code repeats, the LAST occurrence wins (kept
    // as valid); earlier ones are flagged as duplicates and skipped.
    let lastIndexForCode = {};
    data.forEach((row, idx) => {
        let code = String(getCellValue(row, "Consignee Code") || "").trim().toUpperCase();
        if (code) {
            lastIndexForCode[code] = idx;
        }
    });

    data.forEach((row, index) => {
        const rowNumber = index + 2; // Excel row (header = row 1)

        let category = String(getCellValue(row, "Category") || "").trim();
        let customerId = String(getCellValue(row, "Customer Id") || "").trim();
        let consigneeCode = String(getCellValue(row, "Consignee Code") || "").trim();
        let consigneeName = String(getCellValue(row, "Consignee Name") || "").trim();
        let round = String(getCellValue(row, "Round") || "").trim();
        let subRound = String(getCellValue(row, "Sub Round") || "").trim();
        let addrLine1 = String(getCellValue(row, "Address Line 1") || "").trim();
        let addrLine2 = String(getCellValue(row, "Address Line 2") || "").trim();
        let addrLine3 = String(getCellValue(row, "Address Line 3") || "").trim();
        let city = String(getCellValue(row, "City") || "").trim();
        let state = String(getCellValue(row, "State") || "").trim();
        let pincode = String(getCellValue(row, "Pincode") || "").trim();
        let lat = getCellValue(row, "Latitude");
        let lng = getCellValue(row, "Longitude");
        let restrictedVehiclesRaw = String(getCellValue(row, "Restricted Vehicles") || "").trim();
        let cityGrouping = String(getCellValue(row, "City Grouping") || "").trim();
        // OPTIONAL per-consignee zone override. See hasZoneColumn above: a sheet with no Zone
        // column must leave existing mappings alone, while a blank cell in a sheet that HAS the
        // column means "clear the override". Collapsing the two would wipe every mapping the
        // first time someone re-uploads an older sheet.
        let zoneOverride = String(getCellValue(row, "Zone") || "").trim();

        let rowErrors = [];

        // ---- Required fields (all mandatory except Address Line 2 / 3) ----
        if (!category) rowErrors.push(`Category is required`);
        if (!customerId) rowErrors.push(`Customer Id is required`);
        if (!consigneeCode) {
            rowErrors.push(`Consignee Code is required`);
        } else if (existingCodes.has(consigneeCode.toUpperCase())) {
            rowErrors.push(`Consignee Code "${consigneeCode}" already exists`);
        } else if (lastIndexForCode[consigneeCode.toUpperCase()] !== index) {
            rowErrors.push(`Consignee Code "${consigneeCode}" is duplicated in this file - row ${lastIndexForCode[consigneeCode.toUpperCase()] + 2} (the last occurrence) is uploaded instead`);
        }
        if (!consigneeName) rowErrors.push(`Consignee Name is required`);
        if (!round) rowErrors.push(`Round is required`);
        if (!subRound) rowErrors.push(`Sub Round is required`);
        if (!addrLine1) rowErrors.push(`Address Line 1 is required`);
        if (!city) rowErrors.push(`City is required`);
        if (!state) {
            rowErrors.push(`State is required`);
        } else if ((this.state.statesList || []).length > 0) {
            // Must be a State master entry (case / spacing-insensitive), saved in the master's
            // spelling - freight, zone and route lookups match the state exactly.
            const stateKey = state.replace(/\s+/g, " ").toUpperCase();
            const matchedState = this.state.statesList.find(
                (s) => String(s || "").trim().replace(/\s+/g, " ").toUpperCase() === stateKey);
            if (!matchedState) {
                rowErrors.push(`State "${state}" is not in the State master`);
            } else {
                state = String(matchedState).trim();
            }
        }
        if (!pincode) rowErrors.push(`Pincode is required`);
        if (lat === undefined || lat === null || String(lat).trim() === '') rowErrors.push(`Latitude is required`);
        if (lng === undefined || lng === null || String(lng).trim() === '') rowErrors.push(`Longitude is required`);

        // ---- City Grouping: optional - blank defaults to "GROUP1". If a value IS
        // given though, it must be a real entry from the available grouping list
        // (matched case/whitespace-insensitively, then canonicalized to the list's
        // own casing so it stays consistent with manually-added rows). ----
        const matchedCityGroup = cityGrouping
            ? (this.state.cityGroup || []).find((g) => isSameIgnoreCase(g, cityGrouping))
            : null;
        if (cityGrouping && !matchedCityGroup) {
            rowErrors.push(`City Grouping "${cityGrouping}" is not in the available grouping list`);
        }

        if (zoneOverride && validZones.length > 0
                && validZones.indexOf(zoneOverride.toUpperCase()) === -1) {
            rowErrors.push(`Zone "${zoneOverride}" is not configured for this warehouse - leave it blank to use the city/state default`);
        }
        cityGrouping = matchedCityGroup || (cityGrouping ? cityGrouping : "GROUP1");

        // ---- Restricted Vehicles: comma-separated -> array, each name checked against
        // the real vehicle list (this.state.vehicleCap, which already includes the
        // "None"/"All" meta-options alongside the actual vehicle types). Blank is a
        // legitimate value (no restriction), not an error - defaults to ["None"]. ----
        let restrictedVehicles = restrictedVehiclesRaw
            ? restrictedVehiclesRaw.split(',').map((v) => v.trim()).filter((v) => v !== '')
            : [];
        restrictedVehicles = restrictedVehicles.map((v) => {
            const matchedVehicle = findByFieldIgnoreCase(this.state.vehicleCap, "value", v);
            if (!matchedVehicle) {
                rowErrors.push(`Restricted Vehicles "${v}" is not a valid vehicle type`);
            }
            return matchedVehicle ? matchedVehicle.value : v;
        });
        if (restrictedVehicles.length === 0) {
            restrictedVehicles = ["None"];
        }

        if (rowErrors.length > 0) {
            errorList.push({
                row: rowNumber,
                errors: rowErrors
            });
        } else {
            cleanedData.push({
                category: category,
                customer_id: customerId,
                // Uppercased here - the duplicate/existence checks above already
                // compare case-insensitively (existingCodes/lastIndexForCode both
                // key off .toUpperCase()), but the raw as-typed case used to be
                // what actually got saved.
                consignee_code: consigneeCode.toUpperCase(),
                consignee_name: consigneeName,
                round: round,
                sub_round: subRound,
                arrd_line_1: addrLine1,
                arrd_line_2: addrLine2,
                arrd_line_3: addrLine3,
                city: city,
                state: state,
                pincode: pincode,
                lat: lat,
                lng: lng,
                restricted_vehicles: restrictedVehicles,
                city_grouping: cityGrouping,
                ...(hasZoneColumn ? { zone_override: zoneOverride.toUpperCase() } : {}),
            });
        }
    });

    if (cleanedData.length === 0 && errorList.length === 0) {
        errorList.push({
            row: "",
            errors: ["No data found. All rows are empty"]
        });
    }

    this.setState({
        errors: errorList,
        validData: cleanedData
    });

    console.log("Valid Data:", cleanedData);
    console.log("Errors:", errorList);
};

checkFileData()
{
//    console.log("here",this.state.csvData)
    var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
    console.log("verifycsvdata ", vdata)
    if(vdata == true)
    {
        this.setState({
            csvData:'',
            show: true, 
            basicType:'danger', 
            basicTitle:'File contains invalid data',
            uploadFile:'',
            file:""
        });
    }
}

changeFileHandlerLatLng = async (e) => {
    var dt = '';
    const config = {
        headers: [
            
            { 
                name: 'city',
                inputName: 'city',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'lat',
                inputName: 'lat',
                required: false,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'lng',
                inputName: 'lng',
                required: false,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },         
        ]
    }
    var data = CSVFileValidator(e.target.files[0], config)
    .then((csvData) => {
        this.setState({
            csvData:csvData.data
        });
        console.log(csvData.data);
    })
    .catch(err => {})
    // console.log("e.target.files[0]",e.target.result);
    
    var out = new Promise(function(reject, resolve){
        var reader =  new FileReader();
        reader.onload = async function(e) {
            var contents = await e.target.result;
            resolve(contents);
        };
        var tt =  reader.readAsText(e.target.files[0]);
    });

    //this.checkFileData();

    this.setState({
        file:e.target.files[0]
    });
    // console.log("e.target.files[0].type ", e.target.files[0]);

    if(e.target.files[0].type == '' ||e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel')
    {
        // console.log(fileData);
        // console.log(typeof(fileData))
        
    }
    else{
        e.target.value = null;
        this.setState({
            uploadFile:'',
            show: true, 
            basicType:'danger', 
            basicTitle:'Please upload file having extensions .csv only.',
        });
    }
    
}

// Same shape as lmvehiclecapacity.js / lmtransporters.js: only ever submit
// this.state.validData (the already-clean rows) - invalid rows are simply left
// out, matching the "Submit only valid data" partial-upload behavior in the UI.
handleBulkUpload = async () => {
    try {
        this.setState({
            overly:"show-m",
            loadshow:"show-m",
        })

        var reqParams = {
            csvData : this.state.validData,
            loading_port_code : this.state.loading_port_code,
        }
        reqParams['user_name'] = localStorage.getItem('username');
        reqParams['email'] = localStorage.getItem('email');
        reqParams['staff_id'] = localStorage.getItem('staff_id');
        reqParams['user_department'] = localStorage.getItem('lm_department');
        reqParams['designation'] = localStorage.getItem('designation');
        reqParams['comp_code'] = this.state.comp_code;
        reqParams['user_role'] = localStorage.getItem('roles');

        var response = await redirectURL.post("/lmconsignees/importLmConsigneesData",reqParams);
        var existedCodes = response.data.existedCodes || [];
        var insertedCount = response.data.insertedcount || 0;

        if(existedCodes.length > 0){
            // Server-side duplicates (checked against the live DB, not just what's
            // already loaded into this grid) - surface them in the same Validation
            // Errors table as client-side row errors, instead of a SweetAlert with
            // uploaded/exists counts.
            var duplicateErrors = existedCodes.map((code) => ({
                row: "",
                errors: [`Consignee Code "${code}" already exists`]
            }));
            this.setState({
                errors: duplicateErrors,
                validData: [],
                basicTitle : insertedCount > 0 ? "Uploaded Successfully." : "No new records uploaded.",
                basicType : insertedCount > 0 ? "success" : "warning",
                show : true,
                loadshow:"show-n",
                overly:'show-n',
            })
        } else {
            this.setState({
                basicTitle : "Uploaded Successfully.",
                basicType : "success",
                show : true,
                bulkslide:false,
                loadshow:"show-n",
                overly:'show-n',
                fileName:'',
                errors:[],
                validData:[],
            })
            if(this.fileInputRef.current){
                this.fileInputRef.current.value = "";
            }
        }
        this.onLoadPageData();
    } catch(e) {
        console.log(e);
        this.setState({
            basicTitle : "Failed to Upload",
            basicMessage : "",
            basicType : "warning",
            show : true,
            loadshow:"show-n",
            overly:'show-n',
        })
    }
};

onSelectBulkPlants= (location) =>{
    var plants=[];
    try{
        location.map(function(e){
            plants.push(e.value);
        })
        console.log(plants);
        this.setState({
            plant_name : plants
        });
    }
    catch(e)
    {
        console.log(e);
    }
    
}

onCellClickedGrid(row){
    if(row.colDef.field == "delete")
    {
        var rowId = row.data._id;
        //console.log(row.data._id);
        var qry = {
            rowId:rowId,
            consignee_code : row.data.consignee_code,
            comp_code : localStorage.getItem('comp_code'),
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
        }
        //var confirm = confirm("Are You Sure! Do you want really delete?");
        if (window.confirm("Are You Sure! Do you want really delete?"))
        {
            redirectURL.post("/lmconsignees/deleteLmConsignees",qry).then((response)=>{
                console.log(response.data);
                if(response.data.message == "Success")
                {
                    this.setState({
                        basicTitle:"Deleted Successfully.",
                        basicType : "success",
                        show : true
                    })
                    window.location.reload();
                }
                else
                {
                    this.setState({
                        basicTitle:"Failed to Delete.",
                        basicType : "warning",
                        show : true
                    })
                }
            }).catch((e)=>{
                console.log(e);
            })
        }        
    }
}
onRowSelection(event){
    var rowIds=[];
    var rwCount = event.api.getSelectedNodes();
    rwCount.map((item) => {
        rowIds.push(item.data._id)
    });
    
    this.setState({
        rowIds:rowIds
    })
}
componentDidUpdate() {
    if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
        this._lastLoadingPortCode = this.context.loading_port_code;
        this.onGlobalPortChange();
    }
}
onGlobalPortChange = async () => {
    var selectedPlant = this.context.loading_port_code;
    if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
        // Not a valid port for this screen - keep this screen's own selection, don't refetch.
        return;
    }
    this.setState({
        loadshow:'show-m',
        overly:'show-m',
    })
    var params = {
        selectedPlant : selectedPlant,
    }
    redirectURL.post("/lmconsignees/getLoadingPlantDetails",params)
    .then((response) => {
        var res = response.data;
        this.setState({
            loading_port_code : selectedPlant,
            comp_code : res[0].comp_code,
            loadshow:'show-n',
            overly:'show-n',
        })
        this.pageAccess();
    })
    .catch(function(e){
        console.log("Error ",e)
    })
}
  render() {
    var errTrueUpload = this.state.errors.length > 0 && this.state.validData.length > 0
    var disableUpload = this.state.validData.length == 0
    var showActions = false;
    var showDelete = true;
    if(this.state.pageAccess == 2)
    {
        var showActions = true;
    }
    if(this.state.pageAccess == 3)
    {
        var showDelete = false;
    }
    var columnwithDefs = [
        {
            headerName: "",
            field: "_id",
            colId: "row_select_checkbox",
            width: 40,
            pinned: 'left',
            filter: false,resizable: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true
        },
        {
            headerName: "Category",
            field: "category",
            width:130,
            filter: true,
            resizable: true,
            editable:false,
            cellEditor:alphaNumericEditor,            
        },
        {
            headerName: "Customer Id",
            field: "customer_id",
            width:140,
            filter: true,
            resizable: true,
            editable:false,
            cellEditor:alphaNumericEditor,            
        },    
        {
            headerName: "Consignee Code",
            field: "consignee_code",
            width:140,
            filter: true,
            resizable: true,
            editable:false,
            cellEditor:alphaNumericEditor,            
        },
        {
            headerName: "Consignee Name",
            field: "consignee_name",
            width:240,
            filter: true,
            resizable: true,
            editable:false,
            cellEditor:alphaNumericEditor,            
        },
        {
            headerName: "Round",
            field: "round",
            width:80,
            filter: true,
            resizable: true,
            editable:false,
            cellEditor: NumericCellEditor,
        },
        {
            headerName: "Sub Round",
            field: "sub_round",
            width:80,
            filter: true,
            resizable: true,
            editable:false
        },
        {
            headerName: "Address Line 1",
            field: "arrd_line_1",
            width:250,
            filter: true,
            resizable: true,
            editable:false
        },
        {
            headerName: "Address Line 2",
            field: "arrd_line_2",
            width:250,
            filter: true,
            resizable: true,
            editable:false
        },
        {
            headerName: "Address Line 3",
            field: "arrd_line_3",
            width:250,
            filter: true,
            resizable: true,
            editable:false
        },
        {
            headerName: "City",
            field: "city",
            width:180,
            filter: true,
            resizable: true,
            editable:false,            
        },
        {
            headerName: "State",
            field: "state",
            width:180,
            filter: true,
            resizable: true,
            editable:false,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: this.state.statesList,
            },
        },
        {
            headerName: "Pincode",
            field: "pincode",
            width:100,
            filter: true,
            resizable: true,
            editable:false,
            cellEditor: NumericCellEditor,
        },
        {
            headerName: "Latitude",
            field: "lat",
            width:100,
            filter: true,
            resizable: true,
            editable:true,
            cellEditor: NumericCellEditor,
        },
        {
            headerName: "Longitude",
            field: "lng",
            width:100,
            filter: true,
            resizable: true,
            editable:true,
            cellEditor: NumericCellEditor,
        },
        {
            headerName: "Restricted Vehicles",
            field: "restricted_vehicles",
            width:180,
            filter: true,
            resizable: true,
            editable:false
        },
        // {
        //     headerName: "Update Vehicle Restrictions",
        //     field: "update_restricted_vehicles",
        //     width:180,
        //     filter: true,
        //     resizable: true,
        //     editable:false,
        //     // cellEditor: 'agRichSelectCellEditor',
        //     // cellEditorParams: {
        //     //     values: this.state.vehicleCap,
        //     //     multiple:true
        //     // },
        //     cellRenderer: function(params){
        //         let basestring = params.data.batch_name;
        //         let encryptedstring = window.btoa(basestring);
        //         var htmloption = '<button class="btn btn-primary" style="padding-top:0px">Update</button>';
        //         return htmloption;
        //     },
        // },
        {
            headerName: "Zone (override)",
            // NOT the legacy 'zone' field - older saves stamped the state's zone onto every
            // consignee, which must never read as an override.
            field: "zone_override",
            width: 160,
            filter: true,
            resizable: true,
            editable: false,
            // Blank is the normal state: the consignee simply follows its city's zone in Route
            // Config, or its state's default zone in SOB Zones.
            valueFormatter: function (params) { return params.value ? params.value : ""; },
        },
        {
            headerName: "City Grouping",
            field: "city_grouping",
            width:180,
            filter: true,
            resizable: true,
            editable:true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
                values: this.state.cityGroup,
            },
        },
        // {
        //     headerName: "Zone",
        //     field: "zone",
        //     width:100,
        //     filter: true,
        //     resizable: true,
        //     editable:true,
        //     cellEditor: 'agSelectCellEditor',
        //     cellEditorParams: {
        //         values: this.state.zonesList,
        //     },
        // },
        // {
        //     headerName: "Route",
        //     field: "route",
        //     width:100,
        //     filter: true,
        //     resizable: true,
        //     editable:true,
        //     cellEditor: 'agSelectCellEditor',
        //     cellEditorParams: {
        //         values: this.state.routesList,
        //     },
        // },
        {
            pinned:"left",
            headerName : "",
            field:"_id",
            width:50,
            resizable : true,
            editable : false,
            cellRenderer: "actionRenderer",
            hide:showActions
        },
        // {
        //     pinned:"left",
        //     headerName : "Delete",
        //     field:"delete",
        //     width:80,
        //     resizable : true,
        //     editable : false,
        //     cellRenderer:function(params){       
        //         return '<i class="icofont icofont-ui-delete"></i>';
        //     },
        //     hide:showDelete
        // },
    ]
    return (
      <div class="container-fluid" style={{height: "100%"}}>
        <SweetAlert
            show={this.state.show}
            type={this.state.basicType}
            title={this.state.basicTitle}
            onConfirm={this.closeAlert}
        >
            {this.state.basicMessage}
        </SweetAlert>

        <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
            <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0 }}>
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Consignees</h5>
                </div>
                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                    <button className="pill-btn pill-btn-primary" onClick={this.onClickDataExport.bind(this)}>Export Data</button>
                    {(this.state.pageAccess != 2) ?
                    <button className="pill-btn pill-btn-info" onClick={this.showBulkUpload.bind(this)}>Import Data</button>
                    : ""}
                    {(this.state.pageAccess != 2) ?
                    <button className="pill-btn pill-btn-info" onClick={() => {
                        // re-read SOB Zones on every open: a state added to a second zone in
                        // another tab must appear in the template without a page reload
                        this.loadZonesForWarehouse();
                        this.setState({ zoneSlide: true, overly: "show-m" });
                    }}>Zone Overrides</button>
                    : ""}
                    {(this.state.pageAccess != 2) ?
                    <button className="pill-btn pill-btn-success" onClick={this.addNewRow.bind(this)}>+ Add</button>
                    : ""}
                    {/* {(this.state.pageAccess == 3) ?
                    <button className="pill-btn pill-btn-danger" onClick={this.onClickBulkDelete.bind(this)}>Delete</button>
                    : ""} */}
                </div>
            </div>
            <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0, overflowY: "auto" }}>
                <ConsigneesMapView
                    rows={this.state.selectedRows.filter((each) => each.lat && each.lng)}
                    isOpen={this.state.isMapOpen}
                    onToggle={this.toggleMapOpen}
                />
                <div className="ag-theme-balham grid-wrapper mb-3" style={{ flex: this.state.isMapOpen ? "1 1 50%" : "1 1 auto", minHeight: 0 }}>
                <AgGridReact
                    ref={this.gridRef}
                    modules={this.state.modules}
                    columnDefs={columnwithDefs}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true, resizable: true
                    }}
                    rowData={this.state.rowData}
                    enableCharts={false}
                    // autoGroupColumnDef={this.state.autoGroupColumnDef}
                    onGridReady={this.onGridReady}
                    onGridState={this.onGridState}
                    frameworkComponents={this.state.frameworkComponents}
                    statusBar={this.state.statusBar}
                    sideBar={this.state.sideBar}
                    stopEditingWhenGridLosesFocus= {true}
                    pagination={false}
                    gridOptions={{
                        context: { componentParent: this }
                    }}
                    // components={this.state.components}
                    enableRangeSelection= {true}
                    animateRows rowSelection={"multiple"}
                    rowHeight={45}
                    headerHeight={45}
                    onCellClicked={this.onCellClickedGrid.bind(this)}
                    onSelectionChanged={() => {
                        if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
                            const selected = this.gridRef.current.api.getSelectedRows();
                            this.setState({ selectedRows: selected })
                        }
                    }} suppressRowClickSelection={true}
                    />
            </div>
            </div>
        </div>

        
        {/* <button className="btn btn-success" onClick={this.formAssignHandler.bind(this)} style={{marginLeft:"91em"}}>Insert Exports</button> */}
        <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

            <div className="slider-header">
                Import Data
                <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
            </div>

            <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>

                <input
                    ref={this.fileInputRef}
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={this.handleFileChange}
                    style={{ display: "none" }}
                />
                <div className="d-flex align-items-center gap-3">
                    <button
                        className="btn btn-info d-flex justify-content-center p-3"
                        type="button"
                        onClick={() => this.fileInputRef.current.click()}
                    >
                        Upload File
                    </button>

                    <a href={require('../../assets/json/sample_lmconsignee.csv')} target="_blank" className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                        Download Sample Template
                    </a>
                </div>

                {this.state.fileName && (
                    <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                        <span>Selected File :</span>
                        <span
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                flex: 1,
                                fontWeight: "bold"
                            }}
                            title={this.state.fileName}
                        >
                            {this.getShortFileName(this.state.fileName)}
                        </span>
                    </div>
                )}

                {this.state.errors.length > 0 && (
                    <>
                        <h6 className="text-danger mt-3">Validation Errors</h6>

                        <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                            <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                    <tr>
                                        <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                        <th>Error Description</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {this.state.errors.map((err, i) => (
                                        <tr key={i}>
                                            <td className="text-center" style={{ padding: "9px 15px" }}>
                                                {err.row}
                                            </td>

                                            <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                {err.errors.map((e, idx) => (
                                                    <p className="m-0" key={idx}>{e}</p>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}

            </div>
            <div className="slider-footer">
                <button
                    className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                    onClick={this.handleBulkUpload}
                    disabled={disableUpload}
                >
                    {errTrueUpload ? "Submit only valid data" : "Submit"}
                </button>
            </div>

        </div>
        <div className={`hub-slider ${this.state.zoneSlide ? "open" : ""} d-flex flex-column`}>
            <div className="slider-header">
                Zone Overrides
                <span onClick={this.closeZoneSlide} style={{ cursor: "pointer" }}>&#10005;</span>
            </div>
            <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>
                <p style={{ fontSize: "13px", color: "#455a64", marginBottom: "12px" }}>
                    Use this only for consignees in a state that spans more than one zone - a consignee
                    that ships with NCR loads while its neighbours ride upcountry.
                    The template lists exactly those consignees. Fill the <b>Zone</b> column and upload;
                    a blank Zone clears the override so the consignee follows its city, then its state.
                    Only <b>Consignee Code</b> and <b>Zone</b> are read.
                </p>
                {(() => {
                    // Read live from SOB Zones, so a state added to a second zone shows up here
                    // (and in the template) without any code change.
                    var byState = this.state.zonesByState || {};
                    var multi = Object.keys(byState).filter((st) => byState[st].length > 1).sort();
                    return (
                        <div style={{ fontSize: "13px", color: "#455a64", marginBottom: "12px" }}>
                            <b>States spanning more than one zone in this warehouse:</b>
                            {multi.length === 0
                                ? <span> none - every state sits in one zone, so no override is needed.</span>
                                : <ul style={{ margin: "4px 0 0 18px", padding: 0 }}>
                                    {multi.map((st) => (
                                        <li key={st}>{st} &rarr; {byState[st].join(" / ")}</li>
                                    ))}
                                  </ul>}
                        </div>
                    );
                })()}
                <input ref={(el) => { this.zoneFileInput = el; }} type="file" accept=".xlsx,.xls,.csv"
                       onChange={this.handleZoneFile} style={{ display: "none" }} />
                <div className="d-flex align-items-center gap-3">
                    <button className="btn btn-info d-flex justify-content-center p-3" type="button"
                            onClick={() => { if (this.zoneFileInput) { this.zoneFileInput.click(); } }}>
                        Upload File
                    </button>
                    <button className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1" type="button"
                            onClick={this.downloadZoneTemplate}>
                        Download Template
                    </button>
                </div>
                <div style={{ fontSize: "12px", color: "#607d8b", marginTop: "6px" }}>
                    The template will list {this.consigneesNeedingZoneDecision().length} consignee(s).
                </div>
                {this.state.zoneFileName && (
                    <div style={{ marginTop: "15px" }}>
                        Selected File : <b>{this.getShortFileName(this.state.zoneFileName)}</b>
                        {" "}&middot; {this.state.zoneRows.length} row(s) ready
                    </div>
                )}
                {this.state.zoneErrors.length > 0 && (
                    <>
                        <h6 className="text-danger mt-3">Validation Errors</h6>
                        <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                            <table className="table-bordered mb-0 err-table" style={{ width: "100%" }}>
                                <thead className="table-light text-center" style={{ backgroundColor: "#efefef" }}>
                                    <tr>
                                        <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                        <th>Error Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.zoneErrors.map((err, i) => (
                                        <tr key={i}>
                                            <td className="text-center" style={{ padding: "9px 15px" }}>{err.row}</td>
                                            <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                {err.errors.map((m, j) => (<p className="m-0" key={j}>{m}</p>))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </div>
            <div className="slider-footer">
                <button className="save-btn"
                        style={{ margin: "0px", width: "auto", padding: "5px 25px",
                                 cursor: (this.state.zoneRows.length === 0 || this.state.zoneSubmitting) ? "not-allowed" : "pointer",
                                 opacity: (this.state.zoneRows.length === 0 || this.state.zoneSubmitting) ? "0.5" : "1" }}
                        onClick={this.submitZoneUpload}
                        disabled={this.state.zoneRows.length === 0 || this.state.zoneSubmitting}>
                    {this.state.zoneSubmitting ? "Updating..." :
                        (this.state.zoneErrors.length > 0 ? "Submit only valid rows" : "Submit")}
                </button>
            </div>
        </div>
        {this.state.controller.open && (
            <>
                <div
                    className="slider-overlay"
                    onClick={() => { this.setState({ controller: { open: false } }) }}
                />
                <AddEditController
                    resource={this.state.controller}
                    onUpdate={this.onUpdateFreight}
                    closeSlider={() => { this.setState({ controller: { open: false } }) }}
                />
            </>
        )}
        <div className={"dataLoadpage " +(this.state.loadshow)}>
        </div>
        <div className={"dataLoadpageimg " +(this.state.loadshow)}>
            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
        </div>
        <div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
      </div>

    );
  }
}

function dateComparator1(date1,date2){
	//console.log(date1,date2);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split("-")[1]);
	date1 = date1.replace(date1.split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split("-")[1]);
	date2 = date2.replace(date2.split("-")[1],date_2);
	var date1Number = monthToComparableNumber1(date1);
	var date2Number = monthToComparableNumber1(date2);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}	
}

function monthToComparableNumber1(date) {
	console.log(date.length);
	console.log(date);
	if (date === undefined || date === null || date.length !== 10) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}
function dateComparator(date1, date2) {
	// console.log("dateComparator");
	// console.log(date1.length);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
	date1 = date1.replace(date1.split(" ")[0].split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
	date2 = date2.replace(date2.split(" ")[0].split("-")[1],date_2);
	// console.log(date1,date2);
	var date1Number = monthToComparableNumber(date1);
	var date2Number = monthToComparableNumber(date2);
	// console.log(date1Number,date2Number);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}
  }
function monthToComparableNumber(date) {
	// console.log(date,date.length);
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	console.log(yearNumber,monthNumber,dayNumber);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}

function getMonthNumber(monthName){
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
		];
	var monthNum = months.indexOf(monthName)+1;
	if(monthNum < 10){
		monthNum = "0"+monthNum.toString();
	}
	return monthNum;
}


function loadDateTimeScript(){
	// alert("timeDate");
	$('.datetimepicker_mask').datetimepicker({
		//mask:'39-19-9999 29:59',
		format:'d-m-Y'
	});
	$('.datetimepicker_date').datetimepicker({
		mask:'39-19-9999',
		format:'d-m-Y',
		timepicker:false
	});
    var index  =window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src="https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
	//script.src="http://xdsoft.net/jqplugins/datetimepicker/"
	script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}

function DateEditor () {}

// gets called once before the renderer is used
DateEditor.prototype.init = function(params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker:false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function() {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function() {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function() {
	// console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function() {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function() {
    // and we could leave this method out also, false is the default
    return false;
};

function NumericCellEditor() {
}

// gets called once before the renderer is used
NumericCellEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');

    if (isCharNumeric(params.charPress)) {
        this.eInput.value = params.charPress;
    } else {
        if (params.value !== undefined && params.value !== null) {
            this.eInput.value = params.value;
        }
    }

    var that = this;
    this.eInput.addEventListener('keypress', function (event) {
        if (!isKeyPressedNumeric(event)) {
            that.eInput.focus();
            if (event.preventDefault) event.preventDefault();
        } else if (that.isKeyPressedNavigation(event)) {
            event.stopPropagation();
        }
    });

    // only start edit if key pressed is a number, not a letter
    var charPressIsNotANumber = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
};

function getCharCodeFromEvent(event) {
    event = event || window.event;
    return (typeof event.which == "undefined") ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
}

function isCharDecimal(charStr) {
    return !!/\./.test(charStr);
}

function isKeyPressedNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    return isCharNumeric(charStr) || isCharDecimal(charStr);
}

NumericCellEditor.prototype.isKeyPressedNavigation = function (event) {
    return event.keyCode === 39
        || event.keyCode === 37;
};


// gets called once when grid ready to insert the element
NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
NumericCellEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
};

// returns the new value after editing
NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
};

// example - will reject the number if it contains the value 007
// - not very practical, but demonstrates the method.
NumericCellEditor.prototype.isCancelAfterEnd = function () {
    var value = this.getValue();
    return value.indexOf('007') >= 0;
};

// returns the new value after editing
NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
};

// any cleanup we need to be done here
NumericCellEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
};

// if true, then this editor will appear in a popup 
NumericCellEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};

function alphaNumericEditor() {
}

// gets called once before the renderer is used
alphaNumericEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');

    if (isCharAlphaNumeric(params.charPress)) {
        this.eInput.value = params.charPress;
    } else {
        if (params.value !== undefined && params.value !== null) {
            this.eInput.value = params.value;
        }
    }

    var that = this;
    this.eInput.addEventListener('keypress', function (event) {
        if (!isKeyPressedAlphaNumeric(event)) {
            that.eInput.focus();
            if (event.preventDefault) event.preventDefault();
        } else if (that.isKeyPressedNavigation(event)) {
            event.stopPropagation();
        }
    });

    // only start edit if key pressed is a number, not a letter
    var charPressIsNotANumber = params.charPress && ('abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
};

function isCharAlphaNumeric(charStr) {
    return !!/^[A-Za-z0-9 '.-]+$/.test(charStr);
}

function isKeyPressedAlphaNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    return isCharAlphaNumeric(charStr)
}

alphaNumericEditor.prototype.isKeyPressedNavigation = function (event) {
    return event.keyCode === 39
        || event.keyCode === 37;
};


// gets called once when grid ready to insert the element
alphaNumericEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
alphaNumericEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
};

// returns the new value after editing
alphaNumericEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
};

// example - will reject the number if it contains the value 007
// - not very practical, but demonstrates the method.
alphaNumericEditor.prototype.isCancelAfterEnd = function () {
    var value = this.getValue();
    return value.indexOf('007') >= 0;
};

// returns the new value after editing
alphaNumericEditor.prototype.getValue = function () {
    return this.eInput.value;
};

// any cleanup we need to be done here
alphaNumericEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
};

// if true, then this editor will appear in a popup 
alphaNumericEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};
